// @flow

import React, { type Node } from 'react';

export function CashInstructions(): Node {
  return (
    <div style={instructionsTextStyle}>
      Usa esto código para realizar tu pago
    </div>
  );
}

const instructionsTextStyle = {
  margin: '16px 0',
  fontWeight: 400,
  textAlign: 'center',
};
